import { PAGES } from "@/internals/constants/pages";
import { StatsFormFields } from "./stats-block";

const structure = {
  page: PAGES.QR_BUSINESS,
  metaTitle: "_metaTitle",
  metaDescription: "_metaDescription",
  title: "_businessTitle",
  formFields: [
    {
      component: "Accordion",
      title: "_businessNameTitle",
      className: "qrForm",
      formFields: [
        {
          component: "Input",
          type: "text",
          placeholder: "_businessQRNamePlaceholder",
          errorMessage: [{ rule: "maxLength", message: "_businessQRNameMaximumLength" }],
          name: "qrName",
          data_qa: "qr-business-name-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessThemePickerTitle",
      formFields: [
        {
          component: "ThemePicker",
          labelPrimary: "_businessThemePickerLabelPrimary",
          labelSecondary: "_businessThemePickerLabelSecondary",
          id: "qrBusinessThemePicker",
          name: "themeColor",
          data_qa: "qr-business-theme-picker",
            ctaStyle:"rounded"
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessInformationTitle",
      id: "qrbusinessInformation",
      className: "qrbusinessInformation",
      formFields: [
        {
          component: "div",
          className: "u-flex-full",
          formFields: [
            {
              component: "ImageUpload",
              title: "_qrBusinessLogoTitle",
              id: "qrBusinessInformationLogo",
              showEditor: "16/9",
              name: "logoUrl",
              data_qa: "qr-business-logo-image-upload",
              ctaStyle:"rounded"
            },
          ],
        },
        {
          component: "Input",
          type: "text",
          label: "_businessCompanyNameLabel",
          placeholder: "_businessCompanyNamePlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_businessCompanyNameMaximumLength",
            },
          ],
          name: "companyName",
          data_qa: "qr-business-company-name-input",
        },
        {
          component: "Input",
          type: "text",
          label: "_businessTitleLabel",
          placeholder: "_businessTitlePlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_businessCompanyNameMaximumLength",
            },
          ],
          name: "title",
          data_qa: "qr-business-title-input",
        },
        {
          component: "Input",
          type: "text",
          label: "_businessSubtitleLabel",
          placeholder: "_businessSubtitlePlaceholder",
          name: "subtitle",
          data_qa: "qr-business-subtitle-input",
        },
        {
          component: "div",
          className: "button-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_businessButtonLabel",
              placeholder: "_businessButtonPlaceholder",
              errorMessage: [{ rule: "maxLength", message: "_businessButtonMaxLength" }],
              name: "buttonText",
              data_qa: "qr-business-button-text-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_businessUrlLabel",
              placeholder: "_businessUrlPlaceholder",
              errorMessage: [{ rule: "pattern", message: "_invalidLink" }],
              name: "buttonUrl",
              data_qa: "qr-business-button-url-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessOpeningHoursTitle",
      className: "opening-hours",
      formFields: [
        {
          component: "BusinessHours",
          id: "businessHours",
          name: "businessHours",
          ctaStyle:"rounded"
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessLocationTitle",
      className: "location",
      formFields: [
        {
          component: "div",
          className: "address-numeration-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              className: "address",
              label: "_businessAddressLabel",
              placeholder: "_businessAddressPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessAddressMaximumLength",
                },
              ],
              name: "address",
              data_qa: "qr-business-address-input",
            },
            {
              component: "div",
              className: "numeration-wrapper",
              formFields: [
                {
                  component: "Input",
                  type: "text",
                  label: "_businessNumerationLabel",
                  placeholder: "_businessNumerationPlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_businessNumerationMaximumLength",
                    },
                  ],
                  name: "numeration",
                  data_qa: "qr-business-numeration-input",
                },
                {
                  component: "Input",
                  type: "text",
                  label: "_businessZipCodeLabel",
                  placeholder: "_businessZipCodePlaceholder",
                  errorMessage: [
                    {
                      rule: "maxLength",
                      message: "_businessZipCodeMaximumLength",
                    },
                  ],
                  name: "zipCode",
                  data_qa: "qr-business-zip-code-input",
                },
              ],
            },
          ],
        },
        {
          component: "div",
          className: "address-state",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_businessCityLabel",
              className: "city",
              placeholder: "_businessCityPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessCityMaximumLength",
                },
              ],
              name: "city",
              data_qa: "qr-business-city-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_businessStateLabel",
              className: "state",
              placeholder: "_businessStatePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessStateMaximumLength",
                },
              ],
              name: "state",
              data_qa: "qr-business-state-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_businessCountryLabel",
              className: "country",
              placeholder: "_businessCountryPlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessCountryMaximumLength",
                },
              ],
              name: "country",
              data_qa: "qr-business-country-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessFacilitiesTitle",
      formFields: [
        {
          component: "Picker",
          id: "facilitiesPicker",
          multiple: true,
          className: "Picker__list-background",
          options: [
            {
              item: "accommodation",
              tooltip: { text: "Accommodation", position: "top" },
            },
            {
              item: "bar",
              tooltip: { text: "Bar", position: "top" },
            },
            {
              item: "cafe",
              tooltip: { text: "Cafe", position: "top" },
            },
            {
              item: "child-friendly",
              tooltip: { text: "Child friendly", position: "top" },
            },
            {
              item: "parking",
              tooltip: { text: "Parking", position: "top" },
            },
            {
              item: "pet-friendly",
              tooltip: { text: "Pet friendly", position: "top" },
            },
            {
              item: "restaurant",
              tooltip: { text: "Restaurant", position: "top" },
            },
            {
              item: "restrooms",
              tooltip: { text: "Restrooms", position: "top" },
            },
            {
              item: "seating",
              tooltip: { text: "Seating", position: "top" },
            },
            {
              item: "near-public-transport",
              tooltip: { text: "Near public transport", position: "top" },
            },
            {
              item: "taxi",
              tooltip: { text: "Taxi", position: "top" },
            },
            {
              item: "wheelchair-access",
              tooltip: { text: "Wheelchair access", position: "top" },
            },
            {
              item: "wifi",
              tooltip: { text: "Wifi", position: "top" },
            },
          ],
          name: "facilities",
          data_qa: "qr-business-name-picker",
          selector: "icon",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessContactTitle",
      className: "businessContactInfo",
      formFields: [
        {
          component: "div",
          className: "name-phone-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_businessNameLabel",
              placeholder: "_businessNamePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessNameMaximumLength",
                },
              ],
              name: "contactName",
              data_qa: "qr-business-contact-name-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_businessPhoneLabel",
              placeholder: "_businessPhonePlaceholder",
              errorMessage: [
                {
                  rule: "maxLength",
                  message: "_businessPhoneMaximumLength",
                },
              ],
              name: "contactPhone",
              data_qa: "qr-business-contact-phone-input",
            },
          ],
        },
        {
          component: "div",
          className: "email-website-wrapper",
          formFields: [
            {
              component: "Input",
              type: "text",
              label: "_businessEmailLabel",
              placeholder: "_businessEmailPlaceholder",
              errorMessage: [{ rule: "pattern", message: "_businessInvalidEmail" }],
              name: "contactEmail",
              data_qa: "qr-business-contact-email-input",
            },
            {
              component: "Input",
              type: "text",
              label: "_businessWebsiteLabel",
              placeholder: "_businessWebsitePlaceholder",
              errorMessage: [{ rule: "pattern", message: "_businessInvalidLink" }],
              name: "contactWebsite",
              data_qa: "qr-business-contact-website-input",
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessAboutCompanyTitle",
      className: "aboutttt",
      formFields: [
        {
          component: "Input",
          customTag: "textarea",
          type: "text",
          placeholder: "_businessAboutCompanyPlaceholder",
          errorMessage: [
            {
              rule: "maxLength",
              message: "_businessAboutCompanyMaximumLength",
            },
          ],
          name: "aboutTheCompany",
          data_qa: "qr-business-company-about-input",
        },
      ],
    },
    {
      component: "Accordion",
      title: "_businessSocialsTitle",
      formFields: [
        {
          component: "ListPicker",
          id: "qrBusinessSocials",
          title: "_businessSocialsTitleMultiple",
          titleEmpty: "_businessSocialsTitleEmpty",
          name: "socialNetworks",
          data_qa: "qr-business-socials-list-picker",
          options: [
            {
              id: "facebook",
              name: "Facebook",
              value: "",
              data_qa: "facebook-button",
              placeholder: "https://facebook.com/profile",
              tooltip: { text: "Facebook", position: "top" },
            },
            {
              id: "instagram",
              name: "Instagram",
              value: "",
              data_qa: "instagram-button",
              placeholder: "https://instagram.com/profile",
              tooltip: { text: "Instagram", position: "top" },
            },
            {
              id: "twitter",
              name: "Twitter",
              value: "",
              data_qa: "twitter-button",
              placeholder: "https://twitter.com/profile",
              tooltip: { text: "Twitter", position: "top" },
            },
            {
              id: "dribbble",
              name: "Dribbble",
              value: "",
              data_qa: "dribbble-button",
              placeholder: "https://dribbble.com/profile",
              tooltip: { text: "Dribbble", position: "top" },
            },
            {
              id: "flickr",
              name: "Flickr",
              value: "",
              data_qa: "flickr-button",
              placeholder: "https://flickr.com/profile",
              tooltip: { text: "Flickr", position: "top" },
            },
            {
              id: "github",
              name: "Github",
              value: "",
              data_qa: "github-button",
              placeholder: "https://github.com/profile",
              tooltip: { text: "Github", position: "top" },
            },
            {
              id: "line",
              name: "Line",
              value: "",
              data_qa: "line-button",
              placeholder: "https://line.me/profile",
              tooltip: { text: "Line", position: "top" },
            },
            {
              id: "linkedin",
              name: "Linkedin",
              value: "",
              data_qa: "linkedin-button",
              placeholder: "https://linkedin.com/profile",
              tooltip: { text: "Linkedin", position: "top" },
            },
            {
              id: "reddit",
              name: "Reddit",
              value: "",
              data_qa: "reddit-button",
              placeholder: "https://reddit.com/profile",
              tooltip: { text: "Reddit", position: "top" },
            },
            {
              id: "skype",
              name: "Skype",
              value: "",
              data_qa: "skype-button",
              placeholder: "https://skype.com/profile",
              tooltip: { text: "Skype", position: "top" },
            },
            {
              id: "snapchat",
              name: "Snapchat",
              value: "",
              data_qa: "snapchat-button",
              placeholder: "https://snapchat.com/profile",
              tooltip: { text: "Snapchat", position: "top" },
            },
            {
              id: "tiktok",
              name: "Tiktok",
              value: "",
              data_qa: "tiktok-button",
              placeholder: "https://tiktok.com/profile",
              tooltip: { text: "Tiktok", position: "top" },
            },
            {
              id: "tripadvisor",
              name: "Tripadvisor",
              value: "",
              data_qa: "tripadvisor-button",
              placeholder: "https://tripadvisor.com/profile",
              tooltip: { text: "Tripadvisor", position: "top" },
            },
            {
              id: "tumblr",
              name: "Tumblr",
              value: "",
              data_qa: "tumblr-button",
              placeholder: "https://tumblr.com/profile",
              tooltip: { text: "Tumblr", position: "top" },
            },
            {
              id: "vimeo",
              name: "Vimeo",
              value: "",
              data_qa: "vimeo-button",
              placeholder: "https://vimeo.com/profile",
              tooltip: { text: "Vimeo", position: "top" },
            },
            {
              id: "vkontakte",
              name: "Vkontakte",
              value: "",
              data_qa: "vkontakte-button",
              placeholder: "https://vk.com/profile",
              tooltip: { text: "Vkontakte", position: "top" },
            },
            {
              id: "web",
              name: "Web",
              value: "",
              data_qa: "web-button",
              placeholder: "https://web.com/profile",
              tooltip: { text: "Web", position: "top" },
            },
            {
              id: "xing",
              name: "Xing",
              value: "",
              data_qa: "xing-button",
              placeholder: "https://xing.com/profile",
              tooltip: { text: "Xing", position: "top" },
            },
          ],
        },
      ],
    },
    {
      component: "Accordion",
      title: "_statsTitle",
      subtitle: "_statSubtitle",
      className: "qrForm",
      formFields: StatsFormFields(),
    },
  ],
  layoutTranslations: {
    businessPreviewOpeningHours: "_businessPreviewOpeningHours",
    businessPreviewOpeningHoursMonday: "_businessPreviewOpeningHoursMonday",
    businessPreviewOpeningHoursTuesday: "_businessPreviewOpeningHoursTuesday",
    businessPreviewOpeningHoursWednesday: "_businessPreviewOpeningHoursWednesday",
    businessPreviewOpeningHoursThursday: "_businessPreviewOpeningHoursThursday",
    businessPreviewOpeningHoursFriday: "_businessPreviewOpeningHoursFriday",
    businessPreviewOpeningHoursSaturday: "_businessPreviewOpeningHoursSaturday",
    businessPreviewOpeningHoursSunday: "_businessPreviewOpeningHoursSunday",
    businessPreviewLocation: "_businessPreviewLocation",
    businessPreviewZipCode: "_businessPreviewZipCode",
    businessPreviewName: "_businessPreviewName",
    businessPreviewPhone: "_businessPreviewPhone",
    businessPreviewEmail: "_businessPreviewEmail",
    businessPreviewWebsite: "_businessPreviewWebsite",
    businessPreviewFacilities: "_businessPreviewFacilities",
    businessPreviewContactInformation: "_businessPreviewContactInformation",
    businessPreviewAboutTheCompany: "_businessPreviewAboutTheCompany",
    businessPreviewSocialNetworks: "_businessPreviewSocialNetworks",
  },
};

export default structure;
